// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"af322fba","239":"e39fb35b","294":"568f712e","427":"b85da4c0","455":"92e0cc68","457":"3855a000","977":"240addac"}[chunkId] + ".chunk.js";
};